import { Nullable } from '../../foundation'

export type offsetDateTimeISOFormatted = string // new Date().toISOString()

export interface PurchaseInformationCreator {
  hospitalId: number
  campaignId: number
  items: {
    bundleId: number
    quantity: number
  }[]
  reservationId: number | null
}

export interface PurchaseInformation {
  id: number
  hospital: Hospital
  purchaser: Purchaser
  campaign: Campaign
  purchaseItems: PurchaseItem[]
  options: Option[]
  pricing: Pricing
  payment: Payment
  status: string
  purchasedAtDateTime?: offsetDateTimeISOFormatted
  purchaseUid?: string
  cancelPolicyUrl: string
  isUnsealed: boolean
  cancelInfo: CancelInfo
  rewardPoint: RewardPoint
}

export interface CancelInfo {
  cancelActorType: Nullable<'HOSPITAL' | 'USER'>
  cancelReasonCode: Nullable<'WAITED_LONG_TIME' | 'CHANGED_TREATMENT' | 'MISMATCHED_USER_INFO' | 'OTHER'>
  cancelReasonDetail: Nullable<string>
  canceledAtDateTime: Nullable<string>
}

export interface RewardPoint {
  amount: number
  currency: Currency
  state: string
  stateLabel: string
}

export interface Hospital {
  id: number
  name: string
  thumbnailImageUrl: string
  phoneNational?: string
}

export interface Purchaser {
  id: number
  name: string
  phoneCountryCode: string
  phoneNationalNumber: string
}

export interface Campaign {
  id: number
  title: string
  thumbnailImageUrl: string
}

export interface Product {
  id: number
  name: string
}

export interface Bundle {
  id: number
  name: string
}

export interface Item {
  id: number
  name: string
  price: number
  currency: string
}

export interface Pricing {
  price: number
  discount: number
  discountPercent: number
  salePrice: number
  currency: string
}

export interface PurchaseItem {
  product: Product
  bundle: Bundle
  items: Item[]
  pricing: Pricing
  quantity: number
  optionName?: Nullable<string>
  optionsTreatments?: OptionTreatment[]
}

export interface Option {
  id: number
  content: string
  checked: boolean
}

export interface OptionTreatment {
  id: number
  name?: string
  times: number
  unitProperty?: {
    name: string
    value: number
  }
  priceProperties: {
    name: string
    values: string[]
  }[]
}

export enum PayMethodType {
  CARD = 'CARD',
  KAKAOPAY = 'KAKAOPAY',
  NAVERPAY = 'NAVERPAY',
  TOSSPAY = 'TOSSPAY',
  /** 계좌이체 */
  TRANS = 'TRANS',
}

export interface Payment {
  methodType: PayMethodType
  method: string
  description?: string
  loyaltyPointAmount?: number
  pgPaidAmount?: number
}

export interface PrepareForPayment {
  purchaser: {
    name: string
    phoneCountryCode: string // 82
    phoneNationalNumber: string //"1025308945"
  }
  options: {
    id: number
    checked: boolean
  }[]
  paymentMethod: PayMethodType
}

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type Currency = 'KRW' | string
export interface RewardPointRule {
  toBeRewardedPoints: {
    currency: Currency
    amount: number
  } | null
  rule: {
    currency: Currency
    minAmount: number
    maxAmount: number
    label: string
    detail: string[]
  }
}
